import triggerCustomGaEvent from '../analytics/triggerCustomGaEvent'

import _ from 'lodash'

export default function tripTeaseHotelReservation(hotelReservations, urlData) {
	// TripTease reservation event
	let confirmationNumberVal = '',
			currencyVal = 'USD',
			basePriceVal = '',
			totalPriceVal = ''

	if (
		hotelReservations.uniqueId &&
		hotelReservations.uniqueId.id
	) {
		confirmationNumberVal = hotelReservations.uniqueId.id
	}

	if (hotelReservations.roomStays) {
		if (_.get(hotelReservations.roomStays, '[0].total.currencyCode')) {
			currencyVal = hotelReservations.roomStays[0].total.currencyCode
		}

		if (_.get(hotelReservations.roomStays, '[0].total.amountBeforeTax')) {
			basePriceVal = hotelReservations.roomStays[0].total.amountBeforeTax
		}

		if (_.get(hotelReservations.roomStays, '[0].total.amountAfterTax')) {
			totalPriceVal = hotelReservations.roomStays[0].total.amountAfterTax
		}
	}

	const tripTeaseReservationData = {
		"@context": "http://schema.org",
		"@type": "LodgingReservation",
		"reservationId": confirmationNumberVal.toString(),
		"reservationStatus": "http://schema.org/ReservationConfirmed",
		"checkinTime": urlData.startDate.toString(),
		"checkoutTime": urlData.endDate.toString(),
		"totalPrice": totalPriceVal.toString(),
		"basePrice": basePriceVal.toString(),
		"priceCurrency": currencyVal.toString()
	}

	triggerCustomGaEvent('triptease-reservation', tripTeaseReservationData)
}


// WEBPACK FOOTER //
// ./src/utilities/tripTease/tripTeaseHotelReservation.js